<template>
  <div :style="getTitleStyle" v-click-outside="outClose">
    <div
      class="time-select"
      :class="highlight"
      @click="openMenu = !openMenu"
      @mouseenter="showPopup = true"
      @mouseleave="showPopup = false"
    ></div>
    <div v-if="showPopup && selectedTime.id !== undefined">
      <span class="pop-up-time"
        >{{ selectedTime.name }}: {{ selectedTime.from }} -
        {{ selectedTime.to }}</span
      >
    </div>
    <div class="root" v-if="openMenu">
      <div class="scroller-div">
        <div class="radio">
          <p
            class="for-cal-name"
            :style="{
              color: calNameForCountries.color
            }"
          >
            {{ calName }}
          </p>

          <ul>
            <li v-for="timeType in timeTypes" :key="timeType.id">
              <input
                type="radio"
                name="optradio"
                :value="timeType"
                :id="timeType.id"
                :checked="timeType.id === selectedTime.id"
                v-model="selectedTime"
              />
              <label class="radio-label" :for="timeType.id"
                >{{ timeType.name }} -
                <strong>{{
                  kFormatter(countryTimeStats[timeType.id - 1])
                }}</strong></label
              >
            </li>
          </ul>
        </div>
      </div>

      <div class="dropdown-divider"></div>
      <div class="tag-form-btns">
        <a
          class="tag-form-cancel-btn"
          href="javascript:void(0)"
          @click.prevent="closeSelect"
          ><span class="fas fa-times"></span
        ></a>

        <a
          class="tag-form-ok-btn"
          href="javascript:void(0)"
          @click.prevent="resetSelect"
          ><span class="fas fa-sync"></span
        ></a>
      </div>
    </div>
  </div>
</template>

<script>
import ClickOutside from "vue-click-outside";
import apiClientCreator from "../../../../../../helpers/api/request";
import { mapState } from "vuex";

export default {
  name: "MultiSelect.component",
  props: {
    resetList: {
      type: Boolean,
      required: false
    },

    initiatedFiltering: {
      type: Boolean,
      required: false,
      default: () => false
    },
    queryObject: {
      type: Object
    }
  },

  directives: {
    ClickOutside
  },
  data() {
    return {
      selectedTime: {},
      openMenu: false,
      showPopup: false,
      countryTimeStats: [],
      requestCountriesTimeBusy: false,

      timeTypes: [
        {
          id: 1,
          name: "Day",
          from: "08:00",
          to: "20:00"
        },
        {
          id: 2,
          name: "Work Hours",
          from: "10:00",
          to: "16:00"
        },
        {
          id: 3,
          name: "Evening Hours",
          from: "17:00",
          to: "22:00"
        },
        {
          id: 4,
          name: "Night",
          from: "20:00",
          to: "08:00"
        }
      ],
      calName: "Active",
      colorFromCal: "green"
    };
  },
  watch: {
    calNameForCountries: function() {
      this.calName = this.calNameForCountries.calName;
    },
    resetList: function() {
      if (this.resetList === true) {
        this.selectedTime = {};
      }
    },
    selectedTime: function() {
      this.openMenu = false;
      this.$emit("update", this.selectedTime);
    },
    openMenu: function() {
      if (this.openMenu) {
        this.fetchStats();
      }
    },
    initiatedFiltering() {
      if (this.initiatedFiltering) {
        this.countryTimeStats = [];
      }
    }
  },

  methods: {
    outClose() {
      this.openMenu = false;
    },
    kFormatter: function(num) {
      if (num) {
        return Math.abs(num) > 999
          ? Math.sign(num) * (Math.abs(num) / 1000).toFixed(1) + "k"
          : Math.sign(num) * Math.abs(num);
      }
      return 0;
    },
    closeSelect() {
      this.openMenu = false;
    },
    resetSelect() {
      this.selectedTime = {};
    },
    fetchStats() {
      if (!this.requestCountriesTimeBusy) {
        this.requestCountriesTimeBusy = true;
        apiClientCreator(`client/stats/countries/time`)
          .get("", { params: this.queryObject })
          .then(res => {
            res.data.map(item => {
              this.countryTimeStats.push(item);
            });

            this.requestCountriesTimeBusy = false;
          })
          .catch(err => {
            this.requestCountriesTimeBusy = false;
          });
      }
    }
  },

  computed: {
    ...mapState("clients", ["calNameForCountries"]),
    highlight() {
      if (!this.selectedTime.from) {
        return "time-select";
      }
      return "input-highlight";
    },
    getTitleStyle() {
      return {
        "--br-color": this.colorFromCal
      };
    }
  }
};
</script>

<style scoped lang="scss">
$color: var(--br-color);
.root {
  position: absolute;
  top: 30px;
  left: 5px;
  width: max-content;
  min-width: 200px;
  z-index: 10001;
  padding: 5px;
  background-color: #fff;
  border: solid 1px #e4e8ea;
  -webkit-box-shadow: 0 10px 20px rgba(0, 0, 0, 0.1);
  -moz-box-shadow: 0 10px 20px rgba(0, 0, 0, 0.1);
  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.1);
  font-family: Montserrat;
}

ul {
  list-style: none;
  padding-left: 20px;
}

li {
  margin: 5px;
  font-size: 9pt;
  text-align: left;
}

.radio-label {
  margin-left: -15px;
  margin-right: -7px;
  width: max-content;
}

.tag-form-cancel-btn {
  color: red !important;
  float: right;
  margin-right: 5px;
  margin-top: 5px;
}

.tag-form-ok-btn {
  color: green !important;
  float: left;
  margin-left: 5px;
  margin-top: 5px;
}

input[type="search"]::-webkit-search-cancel-button {
  -webkit-appearance: searchfield-cancel-button;
}

input[type="text"],
textarea {
  -webkit-transition: all 0.3s ease-in-out;
  -moz-transition: all 0.3s ease-in-out;
  -ms-transition: all 0.3s ease-in-out;
  -o-transition: all 0.3s ease-in-out;
  outline: none;
  /*  padding: 3px 0px 3px 3px;
        margin: 5px 1px 3px 0px;*/
  border: 1px solid #dddddd;
}

input[type="search"]:focus,
textarea:focus {
  box-shadow: 0 0 5px rgba(81, 203, 238, 1);
  /* padding: 3px 0px 3px 3px;*/
  border: 1px solid rgba(81, 203, 238, 1);
  outline: none !important;
}
input[type="search"]:active {
  outline: none !important;
}

.dropdown-divider {
  height: 1px;
  margin: 9px 0;
  overflow: hidden;
  background-color: #e5e5e5;
}

.time-select {
  cursor: pointer;
  margin-left: 5px;
  width: 0px;
  height: 30px;
  padding: 3px 20px 3px 10px;
  color: black;
  //background: #f5f7ff;
  margin-top: 1px;
  max-width: 100%;
  font-size: 10pt;
  background: url(../../../../../../assets/svg_icons/clock-circular-outline.svg)
    no-repeat right #f5f7ff;
  background-size: 18px;
  background-position: 50% 5px;
  border-radius: 5px;
  //border: 1px solid #546e7a;
  transition-duration: 0.4s;
  border-radius: 5px;
}

.time-select:hover {
  background-color: #e0e0e0;
}

.input-highlight {
  box-shadow: 0 0 5px rgba(81, 203, 238, 1);
  border: 1px solid rgba(81, 203, 238, 1);
  border-radius: 5px;
}

.pop-up-time {
  position: absolute;
  bottom: 40px;
  left: 0px;
  padding: 5px;
  z-index: 10001;
  width: max-content;
  height: min-content;
  background-color: #fff;
  border: solid 1px #90a4ae;
  border-radius: 5px;
  -webkit-box-shadow: 4px 4px 11px -4px rgba(0, 0, 0, 0.75);
  -moz-box-shadow: 4px 4px 11px -4px rgba(0, 0, 0, 0.75);
  box-shadow: 4px 4px 11px -4px rgba(0, 0, 0, 0.75);
}
p.for-cal-name {
  border-bottom: 1px dotted black;
  padding-bottom: 3px;
  color: $color;
}
</style>
